import { createAction, props } from '@ngrx/store';
import { Education } from '@dges/modules/portfolio/domain';
import { EducationEntity } from './education.models';

export const loadEducation = createAction('[Education page] Load Education');

export const loadEducationSuccess = createAction(
  '[Education/API] Load Education Success',
  props<{ education: EducationEntity[] }>(),
);

export const loadEducationFailure = createAction(
  '[Education/API] Load Education Failure',
  props<{ error: unknown }>(),
);

export const addEducation = createAction(
  '[Education page] Add Education',
  props<{ education: Education }>(),
);

export const addEducationSuccess = createAction(
  '[Education/API] Add Education Success',
);

export const addEducationFailure = createAction(
  '[Education/API] Add Education Failure',
  props<{ error: unknown }>(),
);

export const editEducation = createAction(
  '[Education page] Edit Education',
  props<{ education: Education }>(),
);

export const editEducationSuccess = createAction(
  '[Education/API] Edit Education Success',
);

export const editEducationFailure = createAction(
  '[Education/API] Edit Education Failure',
  props<{ error: unknown }>(),
);

export const deleteEducation = createAction(
  '[Education page] Delete Education',
  props<{ education: Education }>(),
);

export const deleteEducationSuccess = createAction(
  '[Education/API] Delete Education Success',
);

export const deleteEducationFailure = createAction(
  '[Education/API] Delete Education Failure',
  props<{ error: unknown }>(),
);
